import React from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

interface PackageNumbersFieldProps {
    qir: any;
    onChange: any;
}
function PackageNumbersField({ qir, onChange }: PackageNumbersFieldProps) {
    const { t } = useTranslation();

    return (
        <Form.Group as={Row} className="mb-1" controlId="packageNumbers">
            <Col sm={3}>
                <OverlayTrigger overlay={<Tooltip>{t<string>('QIRDetail.Fields.PackageToolTip')}</Tooltip>}>
                    <div>
                        <Form.Label>
                            {t<string>('QIRDetail.Fields.Package')}
                        </Form.Label>
                        <FontAwesomeIcon className="ms-3 link" icon={faQuestionCircle} />
                    </div>
                </OverlayTrigger>
            </Col>
            <Col sm={9}>
                <Form.Control type="text" size="sm" value={qir.packageNumbers ?? ""} name="packageNumbers" onChange={onChange} />
            </Col>
        </Form.Group>
    );
}

export default PackageNumbersField;